/* eslint-disable array-callback-return, eqeqeq */
import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import tz from 'dayjs/plugin/timezone';

import {
  sortableContainer,
  sortableElement,
  sortableHandle,
} from 'react-sortable-hoc';
import arrayMove from 'array-move';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from 'highcharts/highcharts-more';
// import { get_chart_options } from '../../options/tv_index';
import Button from '@material-ui/core/Button';
import ReactTooltip from 'react-tooltip';
import icon_info from 'assets/images/icon-info.png';

HighchartsMore(Highcharts);

//const TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
//const OUTPUT_TIME_FORMAT = 'hh:mm:ss A';
const TIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
const OUTPUT_TIME_FORMAT = "hh:mm:ss A";
// const DATE_FORMAT = 'YYYY-MM-DD';

dayjs.extend(utc);
dayjs.extend(tz);

window.moment = dayjs;

var max, min;
const getConfig = ({
  data,
  timezone,
  title,
  zoomType,
  height,
  syncExtremesAg,
  setCustomTimeRange,
  customTimeRange,
}) => {
  const bands = [];

  if (data.sleep_bands) {
    data.sleep_bands.forEach(({ from, to }) => {
      bands.push({
        color: '#39A2DB',
        zIndex: 2,
        from,
        to,
      });
    });
  }
  if (data.awake_bands) {
    data.awake_bands.forEach(({ from, to }) => {
      bands.push({
        color: '#75E6DA',
        zIndex: 2,
        from,
        to,
      });
    });
  }

  if (data.undefined_bands) {
    data.undefined_bands.forEach(({ from, to }) => {
      bands.push({
        color: '#DDE6ED',
        zIndex: 2,
        from,
        to,
      });
    });
  }

  const config = {
    chart: {
      type: 'line',
      height,
      zoomType,
      selection: true,
      panKey: 'alt',
      panning: true,
      borderRadius: 8,
      events: {},
      resetZoomButton: {
        theme: {
          display: 'none',
        },
      },
    },
    time: {
      timezone,
    },
    // title: {
    //   text: 'Body Activity Chart ' + date,
    // },
    xAxis: {
      type: 'datetime',
      // min: Date.UTC(2022, 8, 19, 0, 0),
      // max: Date.UTC(2022, 8, 21, 23, 59),
      min: Number(data.meta_data.graph_start_time),
      max: Number(data.meta_data.graph_stop_time),
      scrollbar: {
        enabled: false,
      },
      startOnTick: false,
      endOnTick: false,
      labels: {
        formatter: function() {
          return dayjs(this.value)
            .tz(timezone)
            .format('HH:mm');
          // return Highcharts.dateFormat('%H:%M', this.value);
        },
      },
      plotBands: bands,
      events: {
        setExtremes: syncExtremesAg,
        load: function(e) {
          if (customTimeRange && customTimeRange.length === 2) {
            let axis = e.target.xAxis[0];
            axis.setExtremes(min, max);
          }

          const containerHeight = window.innerHeight - 300;
          const chartElements = document.querySelectorAll(
            '.charts-wrap:nth-of-type(2) .chart-block',
          );
          const expChartElements = document.querySelectorAll(
            '.charts-wrap:nth-of-type(2) .chart-block.expanded',
          );
          let chartHeight;

          if (expChartElements && expChartElements.length) {
            if (expChartElements.length === 1) {
              chartHeight = containerHeight - 10;
            } else if (expChartElements.length === 2) {
              chartHeight = (containerHeight - 20) / 2;
            } else if (expChartElements.length === 3) {
              chartHeight = (containerHeight - 30) / 3;
            } else if (
              expChartElements.length === 4 ||
              expChartElements.length >= 4
            ) {
              chartHeight = (containerHeight - 40) / 4;
            }
          } else {
            if (chartElements.length > 2) {
              chartHeight = (containerHeight - 20) / 2;
            } else {
              chartHeight = containerHeight - 10;
            }
          }

          for (let i = 0; i < chartElements.length; i++) {
            chartElements[i].style.height = chartHeight + 'px';
          }

          if (e.target) {
            // e.target.reflow();
          }
        },

        selection: function(event) {
          max = event.target.xAxis[0].max;
          min = event.target.xAxis[0].min;
          if (event.xAxis) {
            setCustomTimeRange([event.xAxis[0].max, event.xAxis[0].min]);
          }
        },
      },
      resetZoomButton: {
        theme: {
          display: 'none',
        },
      },
      ordinal: false,
      showLastLabel: true,
    },
    yAxis: {
      // title: {
      //   text: 'Body Activity',
      // },
      min: 0,
      max: 1, // Adjust the maximum value based on your data
      // tickInterval: 20, // Adjust the tick interval based on your data
      opposite: false,
      labels: {
        style: {
          fontFamily: 'Nunito',
          color: '#8F8F8F',
          fontSize: '10px',
        },
        y: 5,
      },
      startOnTick: false,
      endOnTick: false,
      showLastLabel: true,
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      line: {
        marker: {
          enabled: false,
        },
      },
    },
    credits: {
      enabled: false,
    },
    // tooltip: {
    //   formatter: function () {
    //     return 'Timestamp: ' + Highcharts.dateFormat('%Y-%m-%d %H:%M', this.x) + '<br/>' +
    //       'Body Activity: ' + this.y;
    //   },
    // },
    series: [
      {
        name: 'Body Activity',
        type: 'line',
        data: data.line_data,
        color: '#053742',
      },
    ],
    labels: {
      overflow: 'scroll',
    },
    navigator: {
      enabled: false,
    },
    scrollbar: {
      enabled: false,
    },
    exporting: {
      enabled: true,
    },
    rangeSelector: {
      enabled: false,
    },
    tooltip: {
      enabled: true,
      formatter: function() {
        const y = Math.floor(this.y * 100) / 100;
        const x = dayjs.utc(this.x).format('hh:mm A, DD MMM');

        return `<b>Value</b>: ${y} at ${x}`;
      },
    },
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 800,
          },
          chartOptions: {
            rangeSelector: {
              inputEnabled: false,
            },
          },
        },
      ],
    },
    // plotOptions: {
    //   line: {
    //     marker: {
    //       enabled: false,
    //     },
    //   },
    //   series: {
    //     events: {},
    //   },
    // },
  };

  if (title) {
    config.yAxis.title = {
      text: title,
    };
  }

  return config;
};

const ActiGraphCharts = props => {
  const {
    Highstock,
    selected_dates,
    actigraph,
    actigraph_meta,
    zoom_type,
    available_dates,
    update_extremes,
    sorted_dates,
    set_sorted_dates,
    customTimeRange,
    setCustomTimeRange,
    night_view,
    actigraph_view,
    // tv_analytics,
    //   vital_parameters,
    //   show_plotbands
  } = props;
  const [zoomType, set_zoom_type] = useState(zoom_type);

  //   const tooltip_text = {
  //       BR: "Breathing rate of a subject estimated by the radar signal",
  //       HR: "Heart Rate Radar calculated from radar signal using Sleepiz algorithm",
  //       SPO2: "Blood oxygen saturation measured by the SPO2 sensor connected to the Sleepiz device",
  //       PR: "Pulse Rate measured by SPO2 sensor connected to the Sleepiz Device",
  //       SQ: "Different time durations in hour indicating overall quality of the recording, e.g good signal duration, total time in bed, total recording time, total breathing time",
  //       RII: "Respiratory Irregularity Index calculated as total number of irregularly events per hour of total sleep time",
  //       SE: "Sleep efficiency i.e ratio of total sleep time with total time in bed.",
  //   };

  useEffect(() => {
    onClickResetZoom();
  }, [night_view, actigraph_view]);

  const configure_charts = () => {
    ['mousemove', 'touchmove', 'touchstart'].forEach(function(eventType) {
      const charts = document.getElementById('charts');

      if (charts) {
        charts.addEventListener(eventType, function(e) {
          let point, i, event;

          for (i = 0; i < Highstock.charts.length; i = i + 1) {
            let chart = Highstock.charts[i];
            if (chart && chart.pointer) {
              // Find coordinates within the chart
              event = chart.pointer.normalize(e);
              // Get the hovered point
              point = chart.series[0].searchPoint(event, true);

              if (point && point.highlight) {
                point.highlight(e);
              }
            }
          }
        });
      }
    });
  };

  useEffect(configure_charts, []);

  const sliderChangeHandler = () => {
    setTimeout(() => {
      setCustomTimeRange([max, min]);
    }, 10);
  };

  useEffect(() => {
    const charts = document.getElementById('actigraph-time-range-slider');
    if (charts) {
      charts.addEventListener('mouseup', sliderChangeHandler);
      return () => {
        charts.removeEventListener('mouseup', sliderChangeHandler);
      };
    }
  }, []);
  const keyboardNavigation = e => {
    if (e.keyCode == 37) {
      navigateGraphToLeft();
    } else if (e.keyCode == 39) {
      navigateGraphToRight();
    }
  };
  useEffect(() => {
    const charts = document.getElementById('actigraph-time-range-slider');
    if (charts) {
      charts.addEventListener(
        'keydown',
        sliderDebounce(keyboardNavigation, 500),
      );
      return () => charts.removeEventListener('keydown', sliderDebounce);
    }
  }, []);

  var max = '';
  var min = '';
  function syncExtremesAg(e) {
    var thisChart = this.chart;
    if (e.trigger !== 'syncExtremes') {
      // Prevent feedback loop
      const filtered_charts = [];
      Highstock.charts.forEach(chrt => {
        if (chrt && chrt.renderTo.id !== thisChart.renderTo.id) {
          if (
            chrt.renderTo.id === 'actigraph-time-range-slider' ||
            chrt.renderTo.className.includes('actigraph-chart-wrap')
          ) {
            filtered_charts.push(chrt);
          }
        }
      });
      Highstock.each(filtered_charts, function(chart) {
        update_extremes({
          from: e.min,
          to: e.max,
        });
        max = e.max;
        min = e.min;
        if (chart !== thisChart) {
          if (chart && chart.xAxis && chart.xAxis[0].setExtremes) {
            chart.xAxis[0].setExtremes(e.min, e.max, undefined, false, {
              trigger: 'syncExtremes',
            });
          }
        }
      });
    }
  }

  const get_charts = () => {
    const charts_elements = sorted_dates.map((acti_date, index) => {
      if (!Object.keys(selected_dates).find(k => k === acti_date)) {
        return null;
      }

      if (selected_dates && selected_dates[acti_date] && actigraph[acti_date]) {
        return (
          <SortableItem
            key={`item-${acti_date}`}
            index={index}
            acti_date={acti_date}
            expandedClass={'expanded'}
          />
        );
      }

      return null;
    });

    return charts_elements;
  };

  const onSortEnd = ({ oldIndex, newIndex }) => {
    if (selected_dates && Object.keys(selected_dates).length > 1) {
      set_sorted_dates(arrayMove(sorted_dates, oldIndex, newIndex));
    }
  };

  const SortableContainer = sortableContainer(({ children }) => (
    <ul className="charts-wrap" id="charts-AG">
      {children}
    </ul>
  ));

  const DragHandle = sortableHandle(() => (
    <span title="Drag" className="icon drag-icon">
      ::
    </span>
  ));

  const SortableItem = sortableElement(({ acti_date, expandedClass }) => {
    let noData = false;
    if (
      actigraph[acti_date] &&
      actigraph[acti_date] &&
      actigraph[acti_date].length === 0
    ) {
      noData = true;
    }

    return (
      <li
        key={'chart-div-block-' + acti_date}
        className={'chart-block ' + expandedClass}
        style={{ position: 'relative' }}
        id={`chart-${acti_date}`}
      >
        <div className="chart-details expanded-chart-details">
          <div className="chart-details-left">
            <span id="date" style={{ display: 'none' }}>
              {acti_date}
            </span>
            <DragHandle />
            <ReactTooltip
              id="tooltip-drag"
              className="graph-tooltip"
              place="bottom"
            ></ReactTooltip>
            <span className="graph-title">
              {acti_date === 'MOV'
                ? 'Restlessness'
                : available_dates[acti_date]}
            </span>
            <span
              className="icon info-icon"
              data-tip
              data-for={`'tooltip-${acti_date}'`}
            >
              <img src={icon_info} alt="Icon" />
            </span>
          </div>
        </div>
        {noData && (
          <div className="no-data-kpi-block">
            <span className="no-data-kpi-block-content">
              No data available for{' '}
              {acti_date === 'MOV'
                ? 'Restlessness'
                : available_dates[acti_date]}
              .
            </span>
          </div>
        )}
        {!noData && (
          <>
            <HighchartsReact
              kpi_name={available_dates[acti_date]}
              allowChartUpdate={true}
              key={acti_date}
              highcharts={Highstock}
              constructorType="stockChart"
              containerProps={{
                // className: 'chart-container-wrap actigraph-chart-wrap',
                className: 'actigraph-chart-wrap',
                id: 'chart-kpi-' + acti_date,
              }}
              options={getConfig({
                data: actigraph[acti_date],
                timezone: actigraph_meta[acti_date].timezone,
                date: acti_date,
                customTimeRange,
                setCustomTimeRange,
                zoomType,
                title: acti_date,
                height: 150,
                syncExtremesAg,
              })}
            />
                <div
                    style={{
                        position: "absolute",
                        bottom: "15px",
                        right: "15px",
                    }}>
                    <b>WASO: </b>
                    {actigraph[acti_date].meta_data.waso_edited
                    ? actigraph[acti_date].meta_data.waso_edited
                    : "--:--"}
                    &emsp; <b>TST: </b>
                    {actigraph[acti_date].meta_data.total_sleep_time_edited
                    ? actigraph[acti_date].meta_data.total_sleep_time_edited
                    : actigraph[acti_date].meta_data.total_sleep_time
                        ? actigraph[acti_date].meta_data.total_sleep_time
                        : "--:--"}
                    &emsp; <b>SOL: </b>
                    {actigraph[acti_date].meta_data.sol_edited
                    ? actigraph[acti_date].meta_data.sol_edited
                    : "--:--"}
                    &emsp; <b>BED IN TIME: </b>
                    {actigraph[acti_date].meta_data.bed_in_time_edited
                    ? dayjs(
                        actigraph[acti_date].meta_data.bed_in_time_edited,
                        TIME_FORMAT
                        ).format(OUTPUT_TIME_FORMAT)
                    : actigraph[acti_date].meta_data.bed_in_time
                        ? dayjs(
                            actigraph[acti_date].meta_data.bed_in_time,
                            TIME_FORMAT
                        ).format(OUTPUT_TIME_FORMAT)
                        : "--:--"}
                    &emsp; <b>BED OUT TIME: </b>
                    {actigraph[acti_date].meta_data.bed_out_time_edited
                    ? dayjs(
                        actigraph[acti_date].meta_data.bed_out_time_edited,
                        TIME_FORMAT
                        ).format(OUTPUT_TIME_FORMAT)
                    : actigraph[acti_date].meta_data.bed_out_time
                        ? dayjs(
                            actigraph[acti_date].meta_data.bed_out_time,
                            TIME_FORMAT
                        ).format(OUTPUT_TIME_FORMAT)
                        : "--:--"}
              </div>
          </>
        )}
        <div className="chart-details collapse-chart-details">
          <div className="chart-details-right">
            <span
              className="icon info-icon"
              data-tip
              data-for={`'tooltip-${acti_date}'`}
            >
              <img src={icon_info} alt="Icon" />
            </span>
            <span
              title={zoomType === 'xy' ? 'X-axis Zoom' : 'XY-axis Zoom'}
              className={'Y-Zoom'}
            >
              {zoomType === 'xy' && (
                <button
                  className="button"
                  onClick={() => {
                    set_zoom_type('x');
                    console.log('clicked');
                  }}
                >
                  {' '}
                  X
                </button>
              )}
              {zoomType === 'x' && (
                <button
                  className="button"
                  onClick={() => {
                    set_zoom_type('xy');
                    console.log('clicked');
                  }}
                >
                  {' '}
                  XY
                </button>
              )}
            </span>
          </div>
        </div>
        <ReactTooltip
          id={`'tooltip-${acti_date}'`}
          className="graph-tooltip"
          place="bottom"
        >
          {'Actigraph: It represent the rest activity patterns of a patient'}
        </ReactTooltip>
      </li>
    );
  });

  const sliderDebounce = (func, delay) => {
    let debounceTimer;
    return function() {
      const context = this;
      const args = arguments;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(context, args), delay);
    };
  };

  const onClickResetZoom = () => {
    let xMin, xMax;
    Highstock.charts.forEach(chrt => {
      if (chrt) {
        if (
          chrt.renderTo.id === 'actigraph-time-range-slider' ||
          chrt.renderTo.className.includes('actigraph-chart-wrap')
        ) {
          if (chrt.navigator) {
            chrt.zoomOut();
            xMin = chrt.navigator.chart.xAxis[0].min;
            xMax = chrt.navigator.chart.xAxis[0].max;
          }
        }
      }
    });

    set_zoom_type('x');
    update_extremes({
      from: xMin,
      to: xMax,
    });
  };

  const navigateGraphToLeft = () => {
    const charts = Highstock.charts.filter(
      c => c && c.renderTo.id === 'actigraph-time-range-slider',
    );

    charts.map(chart => {
      if (chart && chart.navigator) {
        const selectedRange =
          chart.navigator.chart.xAxis[0].max -
          chart.navigator.chart.xAxis[0].min;

        let min = chart.navigator.chart.xAxis[0].min - selectedRange;
        let max = chart.navigator.chart.xAxis[0].min;

        if (min <= chart.xAxis[1].min) {
          min = chart.xAxis[1].min;
        }

        if (max <= chart.xAxis[1].min) {
          max = chart.navigator.chart.xAxis[0].max;
        }

        chart.xAxis[0].setExtremes(min, max);
        setCustomTimeRange([max, min]);
      }
    });
  };

  const navigateGraphToRight = () => {
    const charts = Highstock.charts.filter(
      c => c && c.renderTo.id === 'actigraph-time-range-slider',
    );

    charts.map(chart => {
      if (chart && chart.navigator) {
        const selectedRange =
          chart.navigator.chart.xAxis[0].max -
          chart.navigator.chart.xAxis[0].min;

        let min = chart.navigator.chart.xAxis[0].max;
        let max = chart.navigator.chart.xAxis[0].max + selectedRange;

        if (max >= chart.xAxis[1].max) {
          max = chart.xAxis[1].max;
        }

        if (min >= chart.xAxis[1].max) {
          min = chart.navigator.chart.xAxis[0].min;
        }

        chart.xAxis[0].setExtremes(min, max);
        setCustomTimeRange([max, min]);
      }
    });
  };

  const getTimeRangeSelector = () => {
    if (
      selected_dates &&
      Object.keys(selected_dates).length > 0 &&
      actigraph &&
      actigraph[Object.keys(selected_dates)[0]]
    ) {
      let totalData = 0;
      let actigraph_slider;
      Object.keys(selected_dates).map(dt => {
        if (actigraph && actigraph[dt] && actigraph[dt].line_data.length > 0) {
          totalData += actigraph[dt].line_data.length;
          actigraph_slider = dt;
        }
      });

      if (totalData === 0) {
        return '';
      }

      const actigraph_date = actigraph_slider;
      const options = {
        rangeSelector: {
          enabled: false,
        },
        tooltip: {
          enabled: false,
        },
        yAxis: {
          height: 0,
          gridLineWidth: 0,
          labels: {
            enabled: false,
          },
        },
        xAxis: {
          lineWidth: 1,
          lineColor: 'rgba(60, 60, 60, 0.3)',
          gridLineColor: 'rgba(60, 60, 60, 0.3)',
          tickLength: 0,
          offset: 35,
          labels: {
            enabled: false,
            align: 'center',
            formatter: function() {
              return Highcharts.dateFormat('%H:%M', this.value);
            },
          },
        },
        plotOptions: {
          series: {
            marker: {
              enabled: false,
            },
          },
          line: {
            marker: {
              enabled: false,
            },
          },
        },
        navigator: {
          enabled: true,
          maskFill: 'rgba(143, 189, 233, 0.25)',
          outlineColor: '#1E87D7',
          outlineWidth: 0,
          height: 44,
          xAxis: {
            ordinal: false,
            labels: {
              align: 'center',
              y: 11,
              style: {
                fontFamily: 'Avenir',
              },
            },
          },
        },
        scrollbar: {
          enabled: false,
        },
        credits: {
          enabled: false,
        },
      };

      let dataset = getConfig({
        date: actigraph_date,
        syncExtremesAg,
        data: actigraph[actigraph_date],
        timezone: actigraph_meta[actigraph_date].timezone,
        zoom_type,
        // customTimeRange,
        // setCustomTimeRange,
        height: 60,
      });

      // let dataset = get_chart_options({
      //     kpi_id: 'MOV',
      //     syncExtremes,
      //     tv_analytics: actigraph[actigraph_date],
      //     zoom_type,
      //     height: 60
      // });

      dataset.rangeSelector = {
        ...dataset.rangeSelector,
        ...options.rangeSelector,
      };
      dataset.tooltip = { ...dataset.tooltip, ...options.tooltip };
      dataset.yAxis = { ...dataset.yAxis, ...options.yAxis };
      dataset.xAxis = { ...dataset.xAxis, ...options.xAxis };
      dataset.plotOptions = { ...dataset.plotOptions, ...options.plotOptions };
      dataset.navigator = { ...dataset.navigator, ...options.navigator };
      dataset.scrollbar = { ...dataset.scrollbar, ...options.scrollbar };

      console.log('range-slider-dataset: ', dataset)

      return (
        <div className="actigraph-range-slider-wrap">
          <HighchartsReact
            allowChartUpdate={false}
            key={'time-range-navigator'}
            highcharts={Highstock}
            constructorType="stockChart"
            options={dataset}
            containerProps={{
              className: 'actigraph-slider-block',
              id: 'actigraph-time-range-slider',
              tabIndex: '1',
            }}
          />
          <div className="range-select-wrap">
            <Button
              disableRipple={true}
              disableFocusRipple={true}
              className="custom-button"
              onClick={onClickResetZoom}
            >
              Reset Zoom
            </Button>
            <div className="range-arrows">
              <span
                tabIndex="1"
                className="zmdi zmdi-chevron-left zmdi-hc-fw"
                onKeyDown={e => {
                  e.persist();
                  if (e.keyCode == 37) {
                    keyboardNavigation(e);
                  }
                }}
                onClick={navigateGraphToLeft}
              ></span>
              <span
                tabIndex="1"
                className="zmdi zmdi-chevron-right zmdi-hc-fw"
                onKeyDown={e => {
                  e.persist();
                  if (e.keyCode == 39) {
                    keyboardNavigation(e);
                  }
                }}
                onClick={navigateGraphToRight}
              ></span>
            </div>
          </div>
        </div>
      );
    }
  };

  return (
    <>
      <SortableContainer
        distance={10}
        lockToContainerEdges={true}
        onSortEnd={onSortEnd}
        useDragHandle={true}
      >
        {get_charts()}
      </SortableContainer>
      {getTimeRangeSelector(zoomType)}
    </>
  );
};

export default React.memo(ActiGraphCharts, (prevProps, nextProps) => {
  return (
    prevProps.selected_actigraph_dates == nextProps.selected_actigraph_dates
    // && prevProps.show_plotbands == nextProps.show_plotbands
  );
});
